<div #outsideModal class="modal">
    <div #modalBody class="modal-content">
        <div class="modal-header"> {{header}} </div>
        <div class="modal-body">
            <form [formGroup]="formGroup" class="form-card-content" (ngSubmit)="onSubmit()" *ngIf="formGroup">
                <frg-form-input label="Libelle" id="libelle" type="text" placeholder="Ex: Recherche multi critère 1"
                            [formGroup]="formGroup" [control]="formGroup.get('libelle')" class="patient-form-input"
                            required="true" ></frg-form-input>
                <div *ngIf="formGroup.get('sublibelle') && nomTable=='RefTypeConsultation'" class="color-picker-container">
                    <div class="color-picker-wrapper">
                        <label>Couleur étiquette  </label>
                        <input id="background-color" name="backgroundColor" [formControl]="formGroup.get('backgroundColor')" type="color">
                    </div>
                </div>
                <div class="button-wrapper"> 
                    <frg-button (activated)="closeRechercheModal()" [backgroundColor]="'var(--darkest-primary)'"
                        [type]="'reset'">Quitter</frg-button>
                    <frg-button *ngIf="!isEdit" [type]="'submit'" [backgroundColor]="'var(--primary)'">Ajouter
                    </frg-button>
                    <frg-button *ngIf="isEdit" [type]="'submit'" [backgroundColor]="'var(--primary)'">Modifier
                    </frg-button>
                </div>
                <div class="error-container group-error" [ngClass]="{'no-height': !isError}">
                    {{errorMessage}}
                </div>
            </form>
        </div>
    </div>
</div>
<div class="modal-background"></div>